<app-loader class="loader" [ngStyle]="{ display: displayStyles }"></app-loader>
<div class="hall">
  <!-- <mat-toolbar color="primary" class="example-toolbar">
  <h1 class="example-app-name">Nested Menus</h1>
</mat-toolbar> -->
  <app-dash-nav></app-dash-nav>
  <mat-sidenav-container class="example-container" autosize>
    <!-- <mat-sidenav #sidenav class="example-sidenav" mode="side" opened="true" (mouseenter)="mouseenter()" (mouseleave)="mouseleave()">
		<mat-nav-list>
			<mat-list-item (click)="showSubmenu = !showSubmenu" class="parent">
				<span class="full-width" *ngIf="isExpanded || isShowing">Profile Name</span>
				<mat-icon mat-list-icon>account_circle</mat-icon>
				<mat-icon class="menu-button" [ngClass]="{'rotated' : showSubmenu}" *ngIf="isExpanded || isShowing">expand_more</mat-icon>
			</mat-list-item>
			<div class="submenu" [ngClass]="{'expanded' : showSubmenu}" *ngIf="isShowing || isExpanded">
				<a mat-list-item>Idea Submission</a>
				<a mat-list-item>Team Details</a> -->
    <!-- <mat-list-item (click)="showSubSubMenu = !showSubSubMenu" class="parent">
					<span class="full-width" *ngIf="isExpanded || isShowing">Nested Menu</span>
					<mat-icon class="menu-button" [ngClass]="{'rotated' : showSubSubMenu}" *ngIf="isExpanded || isShowing">expand_more</mat-icon>
				</mat-list-item>
				<div class="submenu" [ngClass]="{'expanded' : showSubSubMenu}" *ngIf="isShowing || isExpanded">
					<mat-list-item>SubSubmenu Item 1</mat-list-item>
					<mat-list-item>SubSubmenu Item 2</mat-list-item>
				</div> -->
    <!-- </div>
		</mat-nav-list>
    <mat-nav-list>
</mat-nav-list>
	</mat-sidenav> -->

    <div class="example-sidenav-content contents">
      <div class="empty">
        <div *ngIf="showReminder" class="reminder">
          <h2>Reminder</h2>
          <p>
            Please fill the preliminary submission form and choose the track for
            all of your ideas to take part in further evaluation process.
          </p>
          <br />
          <em>Ignore this if all have already been done</em>
          <i
            class="fa fa-xmark"
            aria-hidden="true"
            (click)="showReminder = false"
          ></i>
        </div>
      </div>
      <div *ngIf="true" class="eurekaid">
        <h2>Eureka! ID: {{ this.eureka23id }}</h2>
      </div>
      <div class="eurekaid">
        <h1
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 3rem;
          "
        >
          <!-- <i
            class="fa fa-square"
            style="font-size: small; color: #00c4f4"
            aria-hidden="true"
          ></i> -->
          <span class="headi">UPDATES</span>
          <!-- <i
            class="fa fa-square"
            style="font-size: small; color: #00c4f4"
            aria-hidden="true"
          ></i> -->
        </h1>
      </div>
      <div class="updates">
        <div>
          <div class="congo">
            <ul *ngFor="let lis of uptlis">
              <li style="display: flex; width: 100%">
                <div class="upt">
                  <h3 style="padding-right: 15px">•</h3>
                  <!-- <h3 ></h3> -->
                  <h3>
                    {{ lis.notif }} <br />
                    <a
                      style="color: white"
                      href="{{ lis.link }}"
                      target="_blank"
                      >{{ lis.link }}</a
                    >
                  </h3>
                </div>

                <div class="uptdate">
                  <h3 class="date">{{ lis.date }}</h3>
                </div>
              </li>
            </ul>
            <div *ngIf="!uptlis?.length">
              No updates yet. Stay tuned for more!
            </div>
          </div>
        </div>
      </div>
      <div class="tabs">
        <input type="radio" name="tab" id="tab1" checked="checked" />
        <label for="tab1" class="label1">Idea Submission</label>
        <i
          class="fa fa-square"
          style="font-size: small; color: #3086f8"
          aria-hidden="true"
        ></i>
        <input type="radio" name="tab" id="tab2" />
        <label for="tab2" class="label2">Team Details</label>

        <!-- <h1
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 3rem;
          "
        >
          NOTE: IT'S COMPULSORY TO FILL THE PRELIMINARY SUBMISSION AND CHOOSE
          THE TRACK FOR YOUR IDEA TO TAKE PART IN FURTHER EVALUATION PROCESS.
        </h1> -->
        <!-- <a href="https://ecell.in/eureka/tracks" target="_blank">
    <h1 style="display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 3rem;
    color: #00C4F4;">VIEW TRACKS</h1></a> -->

        <div class="tab-content-wrapper">
          <div id="tab-content-1" class="tab-content">
            <div *ngFor="let lis of lis">
              <div class="card">
                <div class="ace">
                  <img
                    style="margin: 20px"
                    src="https://eureka2022.s3.ap-south-1.amazonaws.com/lightbulb.png"
                    alt=""
                  />
                  <h4>Idea Name: {{ lis.name }}</h4>
                  <h4 class="track-head" *ngIf="lis.track != ''">
                    Track: {{ lis.track }}
                  </h4>
                  <h4 class="sector-head">Sector 1: {{ lis.secA }}</h4>
                  <h4 class="sector-head">Sector 2: {{ lis.secB }}</h4>
                  <div class="but-div-1">
                    <button
                      (click)="prelsub(lis.id, lis.name, lis.track)"
                      type="button"
                      class="btn inverse"
                    >
                      Edit Questionnaire
                    </button>
                  </div>
                  <div class="but-div-2">
                    <button
                      (click)="
                        openPopup4(
                          lis.id,
                          lis.name,
                          lis.secA,
                          lis.secB,
                          lis.desc
                    
                        )
                      "
                      type="button"
                      class="btn inverse"
                    >
                      Idea Details
                    </button>
                    <button
                      type="button"
                      class="btn inverse"
                      (click)="
                        openPopup3(
                          lis.id,
                          lis.name,
                          lis.secA,
                          lis.secB,
                          lis.desc
              
                        )
                      "
                    >
                      Edit Idea
                    </button>
                  </div>
                  <!-- <div class="but-div-1" *ngIf="!lis.track">
                    <button
                      (click)="openPopup6(lis.id)"
                      type="button"
                      class="btn inverse"
                    >
                      Add Track
                    </button>
                  </div> -->
                  <div class="but-div-1" *ngIf="lis.track">
                    <button
                      (click)="openPopup7(lis.id, lis.track)"
                      type="button"
                      class="btn inverse"
                    >
                      Edit Track
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card" (click)="openPopup()" style="cursor: pointer">
              <div class="ace">
                <img class="plus" src="assets/images/plus.png" alt="" />
                <p>Add Idea</p>
              </div>
            </div>
          </div>
          <div id="tab-content-2" class="tab-content">
            <div *ngFor="let list of list">
              <div class="card">
                <div class="ace">
                  <img
                    style="margin: 20px"
                    src="https://eureka2022.s3.ap-south-1.amazonaws.com/account.png"
                    alt=""
                  />
                  <h4>Member Name: {{ list.name }}</h4>
                  <h4 class="track-head">Email: {{ list.email }}</h4>
                  <h4 class="track-head">Contact: {{ list.contact }}</h4>
                  <!-- <h4 class="track-head">Residence: {{list.state}}, {{lis.country}}</h4> -->
                  <!-- <div class="but-div-1">
                      <button type="button" class="btn but but-1">Make preliminary submission</button>
                    </div> -->
                  <div class="but-div-2">
                    <button
                      type="button"
                      class="btn inverse"
                      (click)="
                        memberdetails(
                          list.id,
                          list.name,
                          list.email,
                          list.contact,
                          list.gender
                     
                
                      
                        )
                      "
                    >
                      Member Details
                    </button>
                    <button
                      type="button"
                      class="btn inverse"
                      (click)="
                        openPopup5(
                          list.id,
                          list.name,
                          list.email,
                          list.contact,
                          list.gender
             
      
                        )
                      "
                    >
                      Edit Member
                    </button>
                    <button
                      type="button"
                      class="btn inverse"
                      (click)="deletemember(list.id, list.name, list.email)"
                    >
                      Delete Member
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card" (click)="openPopup2()" style="cursor: pointer">
              <div class="ace">
                <img class="plus" src="assets/images/plus.png" alt="" />
                <p>Add Member</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-container>
</div>

<!-- MODAL -->
<!--       -->

<div
  style="z-index: 1"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: displayStyle }"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content mode">
      <div class="modal-header">
        <div style="float: right; color: white">
          <img
            src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
            alt="close"
            (click)="closePopup()"
          />
        </div>
        <h1
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 3rem;
          "
          class="modal-title"
        >
          <!-- <i
            class="fa fa-square"
            style="font-size: small; color: #00c4f4"
            aria-hidden="true"
          ></i> -->
          <span class="headi">ADD YOUR IDEA</span>
          <!-- <i
            class="fa fa-square"
            style="font-size: small; color: #00c4f4"
            aria-hidden="true"
          ></i> -->
        </h1>
        <!-- <h4 class="modal-title">Register With E-Cell IIT Bombay {{this.idModal}}</h4> -->
      </div>
      <div>
        <form [formGroup]="fourthFormGroup" class="mode main-form">
          <mat-form-field class="input-field" appearance="outline">
            <!-- <mat-label  class="input-label">Startup Name</mat-label> -->
            <input
              style="background-color: tranparent; color: white"
              matInput
              placeholder="Startup Name*"
              formControlName="startup"
              required
            />
            <mat-error
              *ngIf="fourthFormGroup.controls['startup'].hasError('required')"
            >
              Startup Name is required!
            </mat-error> </mat-form-field
          ><br />
          <!-- <mat-form-field class="input-field" appearance="outline">
                <mat-select style="z-index: 5000;" formControlName="track" placeholder="Track*">
                  <mat-option *ngFor="let track of track" [value]="track.value">
                    {{ track.viewValue }}
                  </mat-option>
                </mat-select>
              </mat-form-field><br> -->
          <mat-form-field class="input-field" appearance="outline">
            <!-- <mat-label class="input-label">Sector 1</mat-label> -->
            <mat-select formControlName="sector1" placeholder="Sector 1*">
              <mat-option *ngFor="let sector of sector" [value]="sector.value">
                {{ sector.viewValue }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="fourthFormGroup.controls['sector1'].hasError('required')"
            >
              Sector is required!
            </mat-error> </mat-form-field
          ><br />
          <mat-form-field class="input-field" appearance="outline">
            <!-- <mat-label class="input-label">Sector 2</mat-label> -->
            <mat-select formControlName="sector2" placeholder="Sector 2*">
              <mat-option *ngFor="let sector of sector" [value]="sector.value">
                {{ sector.viewValue }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="fourthFormGroup.controls['sector2'].hasError('required')"
            >
              Sector is required!
            </mat-error>
          </mat-form-field>
          <br />

          <!-- dpiit -->
          <!-- <mat-form-field class="input-field" appearance="outline">
      
            <mat-select
              formControlName="registered"
              placeholder="Is your idea DPIIT registered?"
            >
              <mat-option *ngFor="let bool of bool" [value]="bool.value">
                {{ bool.viewValue }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                fourthFormGroup.controls['registered'].hasError('required')
              "
            >
              This field is required!
            </mat-error> </mat-form-field
          ><br />
          <mat-form-field
            class="input-field"
            appearance="outline"
            *ngIf="
              fourthFormGroup.controls['registered']?.value == bool[0].value
            "
          >
            <input
              matInput
              placeholder="DPIIT Number (optional)"
              formControlName="dpiit"
            /> </mat-form-field
          ><br
            *ngIf="
              fourthFormGroup.controls['registered']?.value == bool[0].value
            "
          /> -->

          <!-- -------------------------------------------------------------------------------------------------- -->
          <!-- <mat-form-field  class="input-field field-white">
              <mat-label>Idea Description</mat-label>
              <input matInput placeholder="Idea Description" formControlName="idea" required>
            </mat-form-field><br> -->
          <mat-form-field class="input-field" appearance="outline">
            <!-- <mat-label class="input-label">Idea Description</mat-label> -->
            <textarea
              matInput
              name="idea"
              placeholder="Idea Description*"
              formControlName="idea"
              required
            ></textarea>
            <mat-error
              *ngIf="fourthFormGroup.controls['idea'].hasError('required')"
            >
              Idea Description is required!
            </mat-error> </mat-form-field
          ><br />
          <!-- <mat-form-field class="input-field" appearance="outline">
            <mat-select formControlName="track" placeholder="Add Track*">
              <mat-option *ngFor="let track of tracks" [value]="track.value">
                {{ track.viewValue }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="fourthFormGroup.controls['track']?.hasError('required')"
            >
              This field is required!
            </mat-error>
          </mat-form-field>
          <br /> -->
          <div>
            <button class="green-button" mat-button (click)="submit2()">
              Submit
            </button>
          </div>
        </form>
      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</div>

<!-- Modal6 -->
<!-- Add Track Modal -->

<div
  style="z-index: 1"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: displayStyle6 }"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content mode">
      <div class="modal-header">
        <div style="float: right; color: white">
          <img
            src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
            alt="close"
            (click)="closePopup6()"
          />
        </div>
        <h1
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 3rem;
          "
          class="modal-title"
        >
          <i
            class="fa fa-square"
            style="font-size: small; color: #00c4f4"
            aria-hidden="true"
          ></i>
          <span class="headi">ADD YOUR TRACK</span>
          <i
            class="fa fa-square"
            style="font-size: small; color: #00c4f4"
            aria-hidden="true"
          ></i>
        </h1>
        <!-- <h4 class="modal-title">Register With E-Cell IIT Bombay {{this.idModal}}</h4> -->
      </div>
      <div>
        <!-- <form [formGroup]="trackFormGroup" class="mode main-form">
          <mat-form-field class="input-field" appearance="outline">
            <mat-select
              style="z-index: 5000"
              formControlName="track"
              placeholder="Track*"
            >
              <mat-option *ngFor="let track of tracks" [value]="track.value">
                {{ track.viewValue }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="trackFormGroup.controls['track'].hasError('required')"
            >
              Track is required!
            </mat-error> </mat-form-field
          ><br />
          <div>
            <button
              class="green-button"
              mat-button
              (click)="submittrack(this.track_ids)"
            >
              Submit
            </button>
          </div>
        </form> -->
      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</div>

<!-- Modal7 -->
<!-- Edit Track Modal -->

<div
  style="z-index: 1"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: displayStyle7 }"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content mode">
      <div class="modal-header">
        <div style="float: right; color: white">
          <img
            src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
            alt="close"
            (click)="closePopup7()"
          />
        </div>
        <h1
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 3rem;
          "
          class="modal-title"
        >
          <!-- <i
            class="fa fa-square"
            style="font-size: small; color: #00c4f4"
            aria-hidden="true"
          ></i> -->
          <span class="headi">EDIT YOUR TRACK</span>
          <!-- <i
            class="fa fa-square"
            style="font-size: small; color: #00c4f4"
            aria-hidden="true"
          ></i> -->
        </h1>
        <!-- <h4 class="modal-title">Register With E-Cell IIT Bombay {{this.idModal}}</h4> -->
      </div>
      <div>
        <!-- <form [formGroup]="trackFormGroup" class="mode main-form">
          <mat-form-field class="input-field" appearance="outline">
            <mat-select
              style="z-index: 5000"
              formControlName="track"
              placeholder="Track*"
            >
              <mat-option *ngFor="let track of tracks" [value]="track.value">
                {{ track.viewValue }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="trackFormGroup.controls['track'].hasError('required')"
            >
              Track is required!
            </mat-error> </mat-form-field
          ><br />
          <div>
            <button
              class="green-button"
              mat-button
              (click)="edittrack(this.track_ids)"
            >
              Submit
            </button>
          </div>
        </form> -->
      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</div>

<!-- MODAL2 -->
<!--   ADD TEAM MEMBER    -->

<div
  style="z-index: 1"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: displayStyle2 }"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content mode">
      <div class="modal-header">
        <div style="float: right; color: white">
          <img
            src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
            alt="close"
            (click)="closePopup2()"
          />
        </div>
        <h1
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 3rem;
          "
          class="modal-title"
        >
          <!-- <i
            class="fa fa-square"
            style="font-size: small; color: #00c4f4"
            aria-hidden="true"
          ></i> -->
          <span class="headi">ADD A MEMBER</span>
          <!-- <i
            class="fa fa-square"
            style="font-size: small; color: #00c4f4"
            aria-hidden="true"
          ></i> -->
        </h1>
        <!-- <h4 class="modal-title">Register With E-Cell IIT Bombay {{this.idModal}}</h4> -->
      </div>
      <div>
        <form [formGroup]="firstFormGroup" class="mode main-form">
          <mat-form-field class="input-field" appearance="outline">
            <!-- <mat-label class="input-label"> Full Name</mat-label> -->
            <input
              matInput
              placeholder="Full Name*"
              formControlName="name"
              required
            />
            <mat-error
              *ngIf="firstFormGroup.controls['name'].hasError('required')"
            >
              Name is required!
            </mat-error> </mat-form-field
          ><br />
          <mat-form-field class="input-field" appearance="outline">
            <!-- <mat-label class="input-label">Email ID</mat-label> -->
            <input
              matInput
              placeholder="Email*"
              name="email"
              pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
              formControlName="email"
              required
            />
            <mat-error
              *ngIf="firstFormGroup.controls['email'].hasError('required')"
            >
              Email is required!
            </mat-error>
            <mat-error
              *ngIf="firstFormGroup.controls['email'].hasError('email')"
            >
              Email is not Valid!
            </mat-error> </mat-form-field
          ><br />
          <mat-form-field class="input-field" appearance="outline">
            <!-- <mat-label class="input-label">Contact Number (Country Code mandatory)</mat-label> -->
            <input
              matInput
              placeholder="Contact Number*"
              name="contact"
              pattern="[0-9+]{10,13}"
              formControlName="contact"
              required
            />
            <mat-error
              *ngIf="firstFormGroup.controls['contact'].hasError('required')"
            >
              Mobile is required!
            </mat-error>
            <mat-error
              *ngIf="firstFormGroup.controls['contact'].hasError('min')"
            >
              Mobile No is Wrong!
            </mat-error>
          </mat-form-field>
          <!-- <br/>
                <mat-form-field  class="input-field" appearance="outline">
                  <mat-select formControlName="country" placeholder="Country*">
                    <mat-option *ngFor="let country of country" [value]="country.value">
                      {{ country.viewValue }}
                    </mat-option>
                  </mat-select>
                </mat-form-field> -->
          <!-- <mat-form-field  class="input-field">
                  <mat-label class="input-label">Contact Number</mat-label>
                  <input matInput placeholder="Contact" formControlName="email" required>
                </mat-form-field> -->
          <br />
          <!-- <mat-form-field class="input-field" appearance="outline">
       
            <mat-select formControlName="state" placeholder="State*">
              <mat-option *ngFor="let state of states" [value]="state.value">
                {{ state.viewValue }}
              </mat-option>
            </mat-select> </mat-form-field
          ><br /> -->
          <!-- <mat-form-field class="input-field" appearance="outline">
         
            <input
              matInput
              placeholder="City*"
              formControlName="city"
              required
            /> </mat-form-field
          ><br /> -->
          <mat-form-field class="input-field" appearance="outline">
            <!-- <mat-label class="input-label">Gender</mat-label> -->
            <mat-select formControlName="gender" placeholder="Gender">
              <mat-option *ngFor="let gender of gender" [value]="gender.value">
                {{ gender.viewValue }}
              </mat-option>
            </mat-select> </mat-form-field
          ><br />
          <!-- <mat-form-field class="input-field" appearance="outline">

            <mat-select
              formControlName="status"
              placeholder="Current professional status?"
            >
              <mat-option *ngFor="let gender of status" [value]="gender.value">
                {{ gender.viewValue }}
              </mat-option>
            </mat-select> </mat-form-field
          ><br /> -->

          <!-- <mat-form-field  class="input-field field-white">
              <mat-label>Idea Description</mat-label>
              <input matInput placeholder="Idea Description" formControlName="idea" required>
            </mat-form-field><br> -->
          <!-- <mat-form-field  class="input-field">
              <mat-label class="input-label">Institute/Workplace</mat-label>
              <input matInput placeholder="Institute" formControlName="institute" required>
            </mat-form-field> -->
          <div>
            <button class="green-button" mat-button (click)="submit()">
              Submit
            </button>
          </div>
        </form>
      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</div>

<div
  style="z-index: 1"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: displayStyle3 }"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content mode">
      <div class="modal-header">
        <div style="float: right; color: white">
          <img
            src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
            alt="close"
            (click)="closePopup3()"
          />
        </div>
        <h1
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 3rem;
          "
          class="modal-title"
        >
          <!-- <i
            class="fa fa-square"
            style="font-size: small; color: #00c4f4"
            aria-hidden="true"
          ></i> -->
          <span class="headi">EDIT YOUR IDEA</span>
          <!-- <i
            class="fa fa-square"
            style="font-size: small; color: #00c4f4"
            aria-hidden="true"
          ></i> -->
        </h1>
        <!-- <h4 class="modal-title">Register With E-Cell IIT Bombay {{this.idModal}}</h4> -->
      </div>
      <div>
        <form [formGroup]="fourthFormGroup" class="mode main-form">
          <mat-form-field class="input-field" appearance="outline">
            <!-- <mat-label  class="input-label">Startup Name</mat-label> -->
            <input
              style="background-color: tranparent; color: white"
              matInput
              placeholder="Startup Name*"
              formControlName="startup"
              required
            />
            <mat-error
              *ngIf="fourthFormGroup.controls['startup'].hasError('required')"
            >
              Startup Name is required!
            </mat-error> </mat-form-field
          ><br />
          <!-- <mat-form-field class="input-field" appearance="outline">
                <mat-select style="z-index: 5000;" formControlName="track" placeholder="Track*">
                  <mat-option *ngFor="let track of tracks" [value]="track.value">
                    {{ track.viewValue }}
                  </mat-option>
                </mat-select>
              </mat-form-field><br> -->
          <mat-form-field class="input-field" appearance="outline">
            <!-- <mat-label class="input-label">Sector 1</mat-label> -->
            <mat-select formControlName="sector1" placeholder="Sector 1*">
              <mat-option *ngFor="let sector of sector" [value]="sector.value">
                {{ sector.viewValue }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="fourthFormGroup.controls['sector1'].hasError('required')"
            >
              Sector is required!
            </mat-error> </mat-form-field
          ><br />
          <mat-form-field class="input-field" appearance="outline">
            <!-- <mat-label class="input-label">Sector 2</mat-label> -->
            <mat-select formControlName="sector2" placeholder="Sector 2*">
              <mat-option *ngFor="let sector of sector" [value]="sector.value">
                {{ sector.viewValue }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="fourthFormGroup.controls['sector2'].hasError('required')"
            >
              Sector is required!
            </mat-error>
          </mat-form-field>
          <br />

<!--           
          <mat-form-field class="input-field" appearance="outline">
            <mat-select
              formControlName="registered"
              placeholder="Is your idea DPIIT registered?"
            >
              <mat-option *ngFor="let bool of bool" [value]="bool.value">
                {{ bool.viewValue }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                fourthFormGroup.controls['registered'].hasError('required')
              "
            >
              This field is required!
            </mat-error> </mat-form-field
          ><br />
          <mat-form-field
            class="input-field"
            appearance="outline"
            *ngIf="
              fourthFormGroup.controls['registered']?.value == bool[0].value
            "
          >
            <input
              matInput
              placeholder="DPIIT Number (optional)"
              formControlName="dpiit"
            /> </mat-form-field
          ><br
            *ngIf="
              fourthFormGroup.controls['registered']?.value == bool[0].value
            "
          /> -->


          <!-- <mat-form-field  class="input-field field-white">
              <mat-label>Idea Description</mat-label>
              <input matInput placeholder="Idea Description" formControlName="idea" required>
            </mat-form-field><br> -->
          <mat-form-field class="input-field" appearance="outline">
            <!-- <mat-label class="input-label">Idea Description</mat-label> -->
            <textarea
              matInput
              name="idea"
              placeholder="Idea Description*"
              formControlName="idea"
              required
            ></textarea></mat-form-field
          ><br />
          <div>
            <button
              class="green-button"
              mat-button
              (click)="submit3(this.idea_ids)"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</div>
<!-- MODAL 4 -->

<div
  style="z-index: 1"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: displayStyle5 }"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content mode">
      <div class="modal-header">
        <div style="float: right; color: white">
          <img
            src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
            alt="close"
            (click)="closePopup5()"
          />
        </div>
        <h1
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 3rem;
          "
          class="modal-title"
        >
          <!-- <i
            class="fa fa-square"
            style="font-size: small; color: #00c4f4"
            aria-hidden="true"
          ></i> -->
          <span class="headi">EDIT TEAM MEMBER DETAILS</span>
          <!-- <i
            class="fa fa-square"
            style="font-size: small; color: #00c4f4"
            aria-hidden="true"
          ></i> -->
        </h1>
        <!-- <h4 class="modal-title">Register With E-Cell IIT Bombay {{this.idModal}}</h4> -->
      </div>
      <div>
        <form [formGroup]="firstFormGroup" class="mode main-form">
          <mat-form-field class="input-field" appearance="outline">
            <!-- <mat-label class="input-label"> Full Name</mat-label> -->
            <input
              matInput
              placeholder="Full Name*"
              formControlName="name"
              required
            />
            <mat-error
              *ngIf="firstFormGroup.controls['name'].hasError('required')"
            >
              Name is required!
            </mat-error> </mat-form-field
          ><br />
          <mat-form-field class="input-field" appearance="outline">
            <!-- <mat-label class="input-label">Email ID</mat-label> -->
            <input
              matInput
              placeholder="Email ID*"
              name="email"
              pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
              formControlName="email"
              required
            />
            <mat-error
              *ngIf="firstFormGroup.controls['email'].hasError('required')"
            >
              Email is required!
            </mat-error>
            <mat-error
              *ngIf="firstFormGroup.controls['email'].hasError('email')"
            >
              Email is not Valid!
            </mat-error> </mat-form-field
          ><br />
          <mat-form-field class="input-field" appearance="outline">
            <!-- <mat-label class="input-label">Contact Number (Country Code mandatory)</mat-label> -->
            <input
              matInput
              placeholder="Contact Number*"
              name="contact"
              pattern="[0-9]{10,13}"
              formControlName="contact"
              required
            />
            <mat-error
              *ngIf="firstFormGroup.controls['contact'].hasError('required')"
            >
              Mobile is required!
            </mat-error>
            <mat-error
              *ngIf="firstFormGroup.controls['contact'].hasError('min')"
            >
              Mobile No is Wrong!
            </mat-error>
          </mat-form-field>
          <!-- <br/>
                <mat-form-field  class="input-field" appearance="outline">
                  <mat-select formControlName="country" placeholder="Country*">
                    <mat-option *ngFor="let country of country" [value]="country.value">
                      {{ country.viewValue }}
                    </mat-option>
                  </mat-select>
                </mat-form-field> -->
          <!-- <mat-form-field  class="input-field">
                  <mat-label class="input-label">Contact Number</mat-label>
                  <input matInput placeholder="Contact" formControlName="email" required>
                </mat-form-field> -->
          <br />
          <!-- <mat-form-field class="input-field" appearance="outline">
     
            <mat-select formControlName="state" placeholder="State*">
              <mat-option *ngFor="let state of states" [value]="state.value">
                {{ state.viewValue }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="firstFormGroup.controls['state'].hasError('required')"
            >
              State is required!
            </mat-error> </mat-form-field
          ><br /> -->


          <!-- <mat-form-field class="input-field" appearance="outline">
      
            <input
              matInput
              placeholder="City*"
              formControlName="city"
              required
            />
            <mat-error
              *ngIf="firstFormGroup.controls['city'].hasError('required')"
            >
              City is required!
            </mat-error> </mat-form-field
          ><br /> -->
          <mat-form-field class="input-field" appearance="outline">
            <!-- <mat-label class="input-label">Gender</mat-label> -->
            <mat-select formControlName="gender" placeholder="Gender*">
              <mat-option *ngFor="let gender of gender" [value]="gender.value">
                {{ gender.viewValue }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="firstFormGroup.controls['gender'].hasError('required')"
            >
              Gender is required!
            </mat-error> </mat-form-field
          ><br />
          <!-- <mat-form-field class="input-field" appearance="outline">
         
            <mat-select
              formControlName="status"
              placeholder="Current professional status?"
            >
              <mat-option *ngFor="let gender of status" [value]="gender.value">
                {{ gender.viewValue }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="firstFormGroup.controls['status'].hasError('required')"
            >
              This field is required!
            </mat-error>
            </mat-form-field>
          <br /> -->
          <div>
            <!-- <button class="green-button" mat-button (click)="submit5('')">Submit</button> -->
            <button
              class="green-button"
              mat-button
              (click)="submit5(this.memb_ids)"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</div>
<!-- MODAL 4 -->
<!--       -->

<div
  style="z-index: 1"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: displayStyle4 }"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content mode">
      <div class="modal-header">
        <div style="float: right; color: white">
          <img
            src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
            alt="close"
            (click)="closePopup4()"
          />
        </div>
        <h1
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 3rem;
          "
          class="modal-title"
        >
          <!-- <i
            class="fa fa-square"
            style="font-size: small; color: #00c4f4"
            aria-hidden="true"
          ></i> -->
          <span class="headi">YOUR IDEA DETAILS</span>
          <!-- <i
            class="fa fa-square"
            style="font-size: small; color: #00c4f4"
            aria-hidden="true"
          ></i> -->
        </h1>
        <!-- <h4 class="modal-title">Register With E-Cell IIT Bombay {{this.idModal}}</h4> -->
      </div>
      <div>
        <div class="ace">
          <img
            style="margin: 20px"
            src="https://eureka2022.s3.ap-south-1.amazonaws.com/lightbulb.png"
            alt=""
          />
          <h4>Idea Name: {{ this.aname }}</h4>
          <!-- <h4 class="track-head">Track: {{this.atrack}}</h4> -->
          <h4 class="sector-head" style="text-transform: capitalize">
            Sector 1: {{ this.asecA }}
          </h4>
          <h4 class="sector-head" style="text-transform: capitalize">
            Sector 2: {{ this.asecB }}
          </h4>
          <h4 class="sector-head">Description: {{ this.adesc }}</h4>
          <!-- <h4 class="sector-head" style="text-transform: capitalize">
            Registered Idea: {{ this.aisReg }}
          </h4> -->
          <!-- <div class="but-div-1">
                  <button (click)="prelsub(lis.id, lis.name)" type="button" class="btn but but-1">Make preliminary submission</button>
                </div>
                <div class="but-div-2">
                  <button type="button" class="btn but but-2">Idea Details</button>
                  <button type="button" class="btn but but-2" (click)=" openPopup3(lis.id)" >Edit Idea</button>
                </div> -->
          <button
            type="button"
            class="btn inverse"
            (click)="deleteidea(this.aid, this.aname)"
          >
            Delete Idea
          </button>
        </div>
      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</div>

<div
  style="z-index: 1"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: displayStyleMember }"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content mode">
      <div class="modal-header">
        <div style="float: right; color: white">
          <img
            src="https://eureka2022.s3.ap-south-1.amazonaws.com/close.png"
            alt="close"
            (click)="closePopupMember()"
          />
        </div>
        <h1
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 3rem;
          "
          class="modal-title"
        >
          <!-- <i
            class="fa fa-square"
            style="font-size: small; color: #00c4f4"
            aria-hidden="true"
          ></i> -->
          <span class="headi">MEMBER DETAILS</span>
          <!-- <i
            class="fa fa-square"
            style="font-size: small; color: #00c4f4"
            aria-hidden="true"
          ></i> -->
        </h1>
        <!-- <h4 class="modal-title">Register With E-Cell IIT Bombay {{this.idModal}}</h4> -->
      </div>
      <div>
        <div class="ace">
          <img
            style="margin: 20px; width: 120px"
            src="https://eureka2022.s3.ap-south-1.amazonaws.com/account.png"
            alt=""
          />
          <h4>Member Name: {{ this.bname }}</h4>
          <h4 class="track-head">Email: {{ this.bemail }}</h4>
          <h4 class="sector-head" style="text-transform: capitalize">
            Contact: {{ this.bcontact }}
          </h4>
          <!-- <h4 class="sector-head" style="text-transform: capitalize;">Country: {{this.bctry}}</h4> -->
          <!-- <h4 class="sector-head">State: {{ this.bstate }}</h4>
          <h4 class="sector-head" style="text-transform: capitalize">
            City: {{ this.bcity }}
          </h4> -->
          <h4 class="sector-head" style="text-transform: capitalize">
            Gender: {{ this.bgender }}
          </h4>
          <!-- <div class="but-div-1">
                  <button (click)="prelsub(lis.id, lis.name)" type="button" class="btn but but-1">Make preliminary submission</button>
                </div>
                <div class="but-div-2">
                  <button type="button" class="btn but but-2">Idea Details</button>
                  <button type="button" class="btn but but-2" (click)=" openPopup3(lis.id)" >Edit Idea</button>
                </div> -->
        </div>
      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</div>
<!-- <div style="color: white; background-color: #192839; padding:20px; border: 1px solid white; text-align: center; font-size:18px;">To avail startup related services at a discounted price visit our STARTUP SERVICES PORTAL
    <a href="https://ecell.in/ssp" target="_blank"><button  class="green-button" mat-button style="font-size: 18px;">Visit Portal</button></a>
  </div> -->
